import { API_ENDPOINTS } from './../../services/api-endpoints-constants';
import { ModelDecoderBindingService } from './../../services/bindingDecoder.model.service';
import { ModelBindingService } from './../../services/binding.model.service';
import { IApiService } from './../../iservices/iApi';
import { IApiBaseObject } from './../../iModels/api-base-object.model';
import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmailerService {
  private apiObject: IApiBaseObject;
  dataHasBeenDeleted = new BehaviorSubject(false);
  tableUpdated = new BehaviorSubject(false);

  constructor( @Inject('IApiService') private apiService: IApiService,
    private modelBindingService: ModelBindingService,
    private modelDecoderBindingService: ModelDecoderBindingService,
    public dialog: MatDialog) {
  }

  getTemplateType() {
    this.apiObject = this.modelBindingService.setApiCallObject(
      `${API_ENDPOINTS.COMMON_CODE}154`,
      {}, true, false);
    return this.apiService.getApi(this.apiObject);
  }

  getTemplateCategory() {
    this.apiObject = this.modelBindingService.setApiCallObject(`${API_ENDPOINTS.COMMON_CODE}153`,
      {}, true, false);
    return this.apiService.getApi(this.apiObject);
  }

  /* postEmailTemplate(data) {
    this.apiObject = this.modelBindingService.setApiCallObject(API_ENDPOINTS.EMAILER,
      data, true, false);
    return this.apiService.postApi(this.apiObject);
  } */
  postEmailTemplate(data) {
    this.apiObject = this.modelBindingService.setApiCallObject(API_ENDPOINTS.EMAILER,
      data, true, false);
    return this.apiService.postApi(this.apiObject);
  }

  getEmailTemplate(apiGetParameters?): any {
    let json;
    if (!_.isEmpty(apiGetParameters)) {
      apiGetParameters.page = apiGetParameters.page ? apiGetParameters.page : 1;
      apiGetParameters.size = apiGetParameters.size === 0 || apiGetParameters.size ? apiGetParameters.size : 10;
    }
    const url = this.modelBindingService.replaceUrl(
      API_ENDPOINTS.EMAILER, apiGetParameters);
    this.apiObject = this.modelBindingService.setApiCallObject(url,
      {}, true, false);
    return this.apiService.getApi(this.apiObject).pipe(
      map((resp: any) => {
        if (resp) {
          if (resp.data) {
            json = {
              data: resp.data,
              'itemCount': resp.data[0].totalRows ? resp.data[0].totalRows : resp.data.length
            };
          } else {
            json = { data: resp.data, 'itemCount': 0 };
          }
          return json;
        }
      }
      ));
  }

  delete(data, type): string {
    const url = `${API_ENDPOINTS.EMAILER}?Id=${data.id}`;
    this.apiObject = this.modelBindingService.setApiCallObject(url, {}, true, false);
    return this.apiService.deleteApi(this.apiObject).pipe(
      map((response) => {
        return response;
      },
        (error) => {
          return error;
        }));
  }
}
